import { React, useState, useRef } from "react";
// import "./Section8Company.css";
import "./PrivateLimitedCompany.css";
import ContactPopup from "./ContactPopup";

const Section8Company = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>Section 8 Company Registration</h1>

        <p className="subtitle">
          Start Your NGO with Legal Recognition
        </p>

        <p className="desc">
          For Charitable, Non-Profit & Social Organizations. We help you register a Section 8 Company smoothly and legally, ensuring full compliance with government regulations so you can focus on your mission and impact.
        </p>

        <div className="badges">
          <span>✔ Ideal for NGOs & Non-Profits</span>
          <span>✔ Tax Benefits & Legal Recognition</span>
          <span>✔ Expert Documentation Support</span>
          <span>✔ End-to-End Assistance</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS */}
      <div className="section">
        <h2>What is a Section 8 Company?</h2>
        <p>
          A Section 8 Company is a non-profit organization registered under the Companies Act, 2013 with the objective of promoting charitable activities such as education, social welfare, environment protection, and more. Profits earned are reinvested into the organization rather than distributed to members.
        </p>
      </div>

      {/* OBJECTIVES */}
      <div className="section">
        <h2>Objectives of Section 8 Company</h2>
        <ul>
          <li>Promotion of education</li>
          <li>Charitable activities</li>
          <li>Social welfare programs</li>
          <li>Environmental protection</li>
          <li>Research and development</li>
          <li>Arts, culture, and sports promotion</li>
        </ul>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of Section 8 Company</h2>
        <ul>
          <li>Tax exemptions under Income Tax Act</li>
          <li>Separate legal identity</li>
          <li>Limited liability for members</li>
          <li>Higher credibility compared to trusts/societies</li>
          <li>No minimum capital requirement</li>
          <li>Eligible for grants and donations</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our Services Include</h2>
        <ul>
          <li>Digital Signature Certificate (DSC)</li>
          <li>Director Identification Number (DIN)</li>
          <li>Name Approval</li>
          <li>MOA & AOA Drafting (NGO specific)</li>
          <li>License under Section 8</li>
          <li>Company Incorporation Certificate</li>
          <li>PAN & TAN Application</li>
          <li>Assistance with 12A & 80G Registration (optional)</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Directors/Members:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof (Bank Statement / Utility Bill)</li>
        </ul>

        <h3>For Registered Office:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill (Electricity/Water)</li>
        </ul>
      </div>

      {/* ELIGIBILITY */}
      <div className="section">
        <h2>Eligibility Criteria</h2>
        <ul>
          <li>Minimum 2 Directors (Private) / 3 Directors (Public)</li>
          <li>At least 1 Director must be an Indian resident</li>
          <li>Objectives must be charitable in nature</li>
          <li>Profits must be used for promoting objectives</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Understand your NGO objectives</li>
          <li>Document Collection – Gather required details</li>
          <li>Name Approval – Reserve NGO name</li>
          <li>License Application – Apply under Section 8</li>
          <li>Incorporation – Get certificate of registration</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>Name Approval</li>
              <li>Section 8 License</li>
              <li>Incorporation</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Everything in Basic</li>
              <li>PAN & TAN</li>
              <li>DSC for Directors</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Everything in Standard</li>
              <li>12A & 80G Assistance</li>
              <li>Compliance Support</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>NGO Registration Experts</li>
          <li>Fast & Reliable Service</li>
          <li>Affordable Pricing</li>
          <li>Transparent Process</li>
          <li>Dedicated Support</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Can profits be distributed?</b> No, must be used for charitable work.</p>
        <p><b>Is Section 8 better than Trust?</b> Yes, more credibility.</p>
        <p><b>How long does registration take?</b> 10–20 working days.</p>
        <p><b>Can foreigners be directors?</b> Yes, with compliance.</p>
      </div>

      {/* CTA */}
      <div className="cta"
        ref={contactRef}>
        <h2>Start Your NGO Today</h2>
        <p>Make a difference with a legally registered organization.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}
          >Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default Section8Company;